import '.a2{position:fixed;}.ssr-plugin'
import '.du{top:0px;}.ssr-plugin'
import '.bo{left:0px;}.ssr-plugin'
import '.bp{right:0px;}.ssr-plugin'
import '.e9{bottom:0px;}.ssr-plugin'
import '.hi{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.hj{z-index:998;}.ssr-plugin'
import '.hk{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a5{height:100vh;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.hl{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.hm{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import '.bz{padding:1.5rem;}.ssr-plugin'
import '.hn{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.ay{flex-shrink:0;}.ssr-plugin'
import '.ch{flex:1;}.ssr-plugin'
import '.au{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a2 du bo bp e9 hi hj hk"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a2 du a5 a8 ah hl hm a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a c a9 bz hn ay"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="ch au bz"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
